const ALWAYS_EMPTY_ARRAY = Object.freeze([]);

// TODO: move into src/utils/values
const asArray = value => (Array.isArray(value) ? value : ALWAYS_EMPTY_ARRAY);

// noinspection JSUnusedGlobalSymbols
export default asArray;
